"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVerifiedToTradeStatus = void 0;
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getVerifiedToTradeStatus = exports.getVerifiedToTradeStatus = function getVerifiedToTradeStatus(verificationLevel, levelIncreaseStatus) {
  var minimumVerificationLevel = _config["default"].KYC.MinimumVerificationLevel;
  var disableTrading = true;
  var isUnderReview = false;
  if (verificationLevel >= minimumVerificationLevel) disableTrading = false;
  if (levelIncreaseStatus === 'underReview') isUnderReview = true;
  if (verificationLevel === levelIncreaseStatus - 1) isUnderReview = true;
  return {
    disableTrading: disableTrading,
    isUnderReview: isUnderReview
  };
};